import React from "react";
import { withFadeTransition } from "../../../../StoreComponents/StoreTransition";
import PayoutRewardList from "./components/PayoutRewardList";

const Payouts = () => {
  return <PayoutRewardList />;
};

export default withFadeTransition(Payouts);
